import { SHIPPER_TYPES } from '@/services/shipper/apis'

// .handoff/ma-ma02__20260804-1447 spec.md · schema.after.json 기준.
// 2026-09-21 컴포넌트 모드 전환 — 조회영역 스펙(FILTER_FIELDS)·표 컬럼(COLUMNS)·페이지 크기는
// 생성본(handoff/page.generated.tsx)이 가지므로 여기서 지웠다. 남은 것은 배선·엑셀이 쓰는 값이다.

export const SERVICE_TYPE_OPTIONS = SHIPPER_TYPES.map((t) => ({ label: t, value: t }))


// schema n-tableheader.exportColumns — 엑셀 다운로드 CSV 컬럼(한글 헤더/순서)
export const EXPORT_COLUMNS: { key: string; title: string }[] = [
  { key: "service_type", title: "화주타입" },
  { key: "shipper_name", title: "화주명" },
  { key: "SPR_NM", title: "화주코드" },
  { key: "GDS_GROUP1", title: "상품군" },
  { key: "BRD_NM", title: "브랜드명" },
  { key: "STL_NO", title: "스타일번호" },
  { key: "BARCODE", title: "바코드명" },
  { key: "GDS_CD", title: "상품코드" },
  { key: "GDS_NM", title: "상품명" },
  { key: "GDS_OPT", title: "상품옵션" },
  { key: "GDS_COLOR", title: "색상" },
  { key: "GDS_ATTR1", title: "상품속성1" },
  { key: "GDS_TYPE", title: "상품유형" },
  { key: "PLT_CD", title: "플랜트코드" },
  { key: "GDS_LOCATION", title: "상품위치" },
  { key: "WH_NM", title: "센터명" },
  { key: "WH_AREA", title: "구역명" },
  { key: "AP_PRICE", title: "매입단가" },
  { key: "AR_PRICE", title: "매출단가" },
  { key: "INS_DATE", title: "생성일자" },
  { key: "INS_BY", title: "생성자" },
  { key: "UPD_DATE", title: "수정일자" },
  { key: "UPD_BY", title: "수정자" },
  { key: "UID", title: "UID" },
  { key: "option_code", title: "옵션코드" },
  { key: "outbound_priority", title: "우선순위" },
  { key: "first_inbound_date", title: "최초입고일" },
  { key: "product_image_url", title: "상품 이미지 URL" },
]

// ── 컴포넌트 모드 전환(2026-09-21) — 아래는 삭제된 화면 컴포넌트에 있던 상수다.
//    UI 는 컨덕터 생성본(handoff/page.generated.tsx)이 그리고, 검증·기본값은 배선(index.tsx)이 쓴다.

/** 화주 없이 조회하면 전 화주 상품이 통째로 실린다 — 화면의 별표대로 배선에서 막는다(구 ProductManagementFilter). */
export const SHIPPER_REQUIRED_MESSAGE = '화주(유형 또는 명)를 선택해 주세요.'
export const SHIPPER_LOAD_FAILED_MESSAGE = '화주 목록을 불러오지 못했습니다. 새로고침한 뒤 다시 시도해 주세요.'

/** 상품코드 검색 모달 — goods-codes 는 무페이징 distinct 라 조건 없는 [조회]는 받지 않는다(재고 화면들과 같은 문구). */
export const GOODS_HELPER_CONDITION_REQUIRED_MESSAGE = '브랜드명 또는 상품명을 입력 후 조회해 주세요.'

/** 다운로드 사유 상세 최소 글자 수(구 ExcelDownloadReasonModal) — 배선의 `_ok` 가 검증하고 실패는 throw. */
export const REASON_DETAIL_MIN_LENGTH = 5

/** 엑셀 업로드로 만든 신규 행의 빈 틀(구 ProductManagementTable EMPTY_ROW). 저장 시 `_isNew` 가 POST 로 간다. */
export const EMPTY_PRODUCT_ROW = {
  _isNew: true,
  _companyName: null,
  _unitCode: null,
  service_type: '',
  shipper_name: '',
  SPR_NM: '',
  GDS_GROUP1: '',
  BRD_NM: '',
  STL_NO: '',
  BARCODE: '',
  GDS_CD: '',
  GDS_NM: '',
  GDS_OPT: '',
  GDS_COLOR: '',
  GDS_ATTR1: '',
  GDS_TYPE: '',
  PLT_CD: '',
  GDS_LOCATION: '',
  WH_NM: '',
  WH_AREA: '',
  AP_PRICE: null,
  AR_PRICE: null,
  INS_DATE: '',
  INS_BY: '',
  UPD_DATE: '',
  UPD_BY: '',
  UID: '',
  option_code: '',
  outbound_priority: null,
  first_inbound_date: '',
  product_image_url: '',
} as const
